import FixaPill from "../../../wrappers/FixaPill/FixaPill";
import CrossIconPath from "../../../wrappers/FixaSSRIcon/paths/CrossIconPath";
import {
  FilterValue,
  MultiSelectFilter,
  SelectOption,
  StringArrayFilterValue,
} from "../../types/filter";
import {
  getInputFilterValueCount,
  removeFilterValueFromValues,
} from "../../utils/filter/filtervalue";
import { isSelectGroup, isSelectOption } from "../../utils/filter/selectoption";

interface AppliedSelectPillProps {
  filter: MultiSelectFilter;
  filterValue: StringArrayFilterValue | undefined;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
}

export const AppliedMultiSelectPill = ({
  filter,
  filterValue,
  filterValues,
  setFilterValues,
}: AppliedSelectPillProps) => {
  const { id, title } = filter;

  if (
    filterValue &&
    getInputFilterValueCount(filterValue, filter.defaultValue)
  ) {
    const handleOnClick = (value: string) => {
      const newFilterValues = removeFilterValueFromValues(filterValues, id);
      const newFilterValueValue = filterValue.value.filter(
        (filterValue) => filterValue !== value
      );
      if (newFilterValueValue.length) {
        newFilterValues.push({ ...filterValue, value: newFilterValueValue });
      }
      setFilterValues(newFilterValues);
    };

    return (
      <>
        {filterValue.value.map((value) => {
          const option = filter.options
            .flatMap((option) =>
              isSelectGroup(option) ? option.options : option
            )
            .filter((option) => isSelectOption(option))
            .find((option) => (option as SelectOption).value === value);
          return (
            <FixaPill
              key={`${filter.id}-${value}`}
              trailingIcon={CrossIconPath}
              selected
              label={title + ": " + (option?.title ?? filterValue.value)}
              onClick={() => {
                handleOnClick(value);
              }}
              size="small"
            />
          );
        })}
      </>
    );
  } else {
    return null;
  }
};
